import React from 'react'
import ReadyToServe from '../components/ReadyToServe'
import NavbarWrapper from '../components/Navbar/NavbarWrapper'

function ReadyOrders () {
    return(
        <div>
            <NavbarWrapper /> 
            <ReadyToServe /> 
        </div> 
        )
}

export default ReadyOrders